import React from "react";
import ReactApexChart from "react-apexcharts";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import MDBox from "components/MDBox";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const ViewGraficoProcesos = (props: any) => {
  //   console.log("ViewGraficoProcesos props...", props);
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <MDBox sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Métricas CPU" {...a11yProps(0)} />
          <Tab label="Métricas Memoria" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <ApexBarAgrupa categories={props.categories} series={props.series} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ApexBarAgrupa categories={props.categories} series={props.seriesRam} />
      </CustomTabPanel>
    </MDBox>
  );
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function ApexBarAgrupa(props: any) {
  const seriesTransformadas = props.series.map((serie: any) => ({
    name: serie.name,
    data: props.categories.map((timestamp: number, i: number) => ({
      x: timestamp,
      y: serie.data[i],
    })),
  }));

  const options = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      id: "procesosEc2",
      toolbar: { show: true },
      zoom: { enabled: true },
    },
    xaxis: {
      type: "datetime",
      labels: {
        format: "HH:mm",
        datetimeUTC: false,
      },
    },
    tooltip: {
      x: {
        format: "dd/MM/yyyy HH:mm:ss",
      },
    },
    yaxis: {
      max: 100,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 4,
        dataLabels: {
          total: {
            enabled: true,
            formatter: (val: number) => val.toFixed(2),
            style: { fontSize: "12px", fontWeight: 900 },
          },
        },
      },
    },
    legend: {
      position: "right",
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={seriesTransformadas}
      type="bar"
      height={200}
      width={1200}
    />
  );
}

export default ViewGraficoProcesos;
